// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"gift"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 15L22 7L2 7L2 15L22 15Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M22 21L22 15L2 15L2 21L22 21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 21L2 21M22 21V7L2 7L2 21M22 21V15L2 15L2 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 4C12 5.65685 10.6569 7 9 7C7.34315 7 6 5.65685 6 4C6 2.34315 7.34315 1 9 1C10.6569 1 12 2.34315 12 4ZM12 4C12 5.65685 13.3431 7 15 7C16.6569 7 18 5.65685 18 4C18 2.34315 16.6569 1 15 1C13.3431 1 12 2.34315 12 4ZM8 11L12 7L16 11","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-gift')
export default class GiftIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gift',
    }
  }
}
